import { render, staticRenderFns } from "./back-editproductdetail.vue?vue&type=template&id=68029d4b&"
import script from "./back-editproductdetail.vue?vue&type=script&lang=ts&"
export * from "./back-editproductdetail.vue?vue&type=script&lang=ts&"
import style0 from "./back-editproductdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports